import {ProjectNs} from "@shared/types/project.namespace";

export namespace ContainerNs {

  export interface GetContainerRequest {
    workspaceId: string,
  }

  export interface Container {
    id: number,
    name: string,
    projectList: ProjectNs.Project[]
  }

  /** Add Container */
  export interface AddContainerRequest {
    workspaceId: string,
    containerName: string
  }

  /** Change Container Name */

  export interface ChangeContainerNameRequest {
    workspaceId: string,
    containerId: number,
    containerName: string,
  }

  /** Remove Container */

  export interface RemoveContainerRequest {
    workspaceId: string,
    containerId: number
  }

  /** Container Enums */
  export enum ContainerEnums {
    DEFAULT_NAME = 'Untitled Container'
  }

}
